
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import OwcDataComponent from '@owc-utils/Mixins/OwcDataComponent';
import SlotContainer from '@owc-packages/SlotContainer/src/SlotContainer.vue';
import GenericImage from '@owc-packages/GenericImage/src/GenericImage.vue';
import { MediaSliderItemComponent } from './MediaSliderItem';
import { ItemType } from './MediaSliderItem.enums';
import VideoPlayer from '@owc-packages/VideoPlayer/src/VideoPlayer.vue';
import { TrackingInstance } from '@owc-packages/Tracking/src/Tracking';
import initializeTracking, { formatTrackingString } from '@owc-packages/Tracking/src/TrackingUtils';
import ValidationBoxWrapper from '@owc-packages/ValidationBox/src';
import { setBrandTheme } from '@owc-utils/Theming/theming';

let trackingInstance: TrackingInstance | null = null;

export default (ComponentInitializeDispatcher as MediaSliderItemComponent).extend({
  mixins: [OwcDataComponent],
  name: 'owc-media-slider-item',
  components: {
    GenericImage,
    VideoPlayer,
    SlotContainer,
    ValidationBoxWrapper,
  },
  async mounted() {
    trackingInstance = await initializeTracking();

    // To be removed when Workbench releases theming
    // https://pages.git.i.mercedes-benz.com/dh-io-workbench/documentation/v7/foundations/colour-system/
    const componentBrand = (this.$el.getRootNode() as ShadowRoot).host as HTMLDivElement;
    setBrandTheme(componentBrand);
  },
  methods: {
    isImage(item) {
      return item === ItemType.image;
    },
    handleTracking(labelPrefix, url) {
      if (trackingInstance) {
        const title = this.$refs.title.textContent || '';
        trackingInstance.customTrackingObjectUpdate(
          {
            label: `${labelPrefix}.${formatTrackingString(title)}`,
            category: 'link',
            URL: url,
          },
          'click',
          this.$el,
        );
      }
    },
  },
  computed: {
    title() {
      return this.componentData?.title;
    },
    description() {
      return this.componentData?.description;
    },
    ctaData() {
      return this.componentData?.buttonData;
    },
    type() {
      return this.componentData?.type;
    },
    isActive() {
      return this.componentData?.isActive;
    },
    darkMode() {
      return this.componentData?.darkMode;
    },
  },
});
